// removed by extract-text-webpack-plugin
module.exports = {"link":"main__link___2RvrT","linkList":"main__linkList___3YlF7","time":"main__time___KFsNW","detail":"main__detail___wsMwS"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/main.scss
// module id = 540
// module chunks = 0